export class ExportConfiguration {
  constructor(
    public id: number,
    public name: string,
    public headers: { type: ExportConfigurationHeaderType; value: any }[],
  ) {}
}

export enum ExportConfigurationHeaderType {
  Date = 1,
  StartTime,
  EndTime,
  MediaId,
  MediaName,
  MediaDescription,
  Metadata,
  Duration,
  ShowName,
}
